import { render } from "./ViewPuzzle.vue?vue&type=template&id=07f34d0c"
import script from "./ViewPuzzle.vue?vue&type=script&lang=js"
export * from "./ViewPuzzle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__